export interface ClientData {
    src: string
    alt: string
    id: string
}

// 掲載企業ロゴ。画像は lp/foodslabo/*/shared/sections/RecruitmentPostingCompany と
// 同じアセットを使うが、あちらは現在どのページからも描画されていないため
// （import元にすると生きているように見えてしまう）データはここに持つ。
export const CLIENT_LOGOS: ClientData[] = [
    {
        id: 'client1',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo1.png',
        alt: 'Eggsn Thingsロゴ'
    },
    {
        id: 'client2',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo2.png',
        alt: 'スシローロゴ'
    },
    {
        id: 'client3',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo3.png',
        alt: 'TRANSITロゴ'
    },
    {
        id: 'client4',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo4.png',
        alt: 'PIERRE HERMÉロゴ'
    },
    {
        id: 'client5',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo5.png',
        alt: '王将ロゴ'
    },
    {
        id: 'client6',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo6.png',
        alt: 'Gong chaロゴ'
    },
    {
        id: 'client7',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo7.png',
        alt: 'Saizeriyaロゴ'
    },
    {
        id: 'client8',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo8.png',
        alt: '焼肉キングロゴ'
    },
    {
        id: 'client9',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo9.png',
        alt: 'DD GROUPロゴ'
    },
    {
        id: 'client10',
        src: '/renewal_lp/RecruitmentPostingCompany/clientLogo10.png',
        alt: '丸亀製麺ロゴ'
    }
]
